"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Button = _interopRequireDefault(require("../Button"));
var _getObjectSubset = _interopRequireDefault(require("../utils/getObjectSubset"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/* babel-plugin-inline-import './Down-Default.svg' */
var downArrow = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPjxkZWZzPjxwYXRoIGQ9Ik03LjU1NyA5LjM1NGw0LjQxNyA0LjQxNiA0LjQ4My00LjMyOWEuOTEzLjkxMyAwIDExMS4yNjkgMS4zMTRsLTUuMDc2IDQuOWEuOTE4LjkxOCAwIDAxLS43ODYuMjQ5LjkxMi45MTIgMCAwMS0uNjEtLjI3bC00Ljk4OC00Ljk5YS45MTMuOTEzIDAgMTExLjI5LTEuMjl6IiBpZD0iYSIvPjwvZGVmcz48dXNlIGZpbGw9IiM1NTYyNzIiIGZpbGwtcnVsZT0ibm9uemVybyIgeGxpbms6aHJlZj0iI2EiLz48L3N2Zz4=";
/* babel-plugin-inline-import './Down-Light.svg' */
var downArrowLight = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPjxkZWZzPjxwYXRoIGQ9Ik03LjU1NyA5LjM1NGw0LjQxNyA0LjQxNiA0LjQ4My00LjMyOWEuOTEzLjkxMyAwIDExMS4yNjkgMS4zMTRsLTUuMDc2IDQuOWEuOTE4LjkxOCAwIDAxLS43ODYuMjQ5LjkxMi45MTIgMCAwMS0uNjEtLjI3bC00Ljk4OC00Ljk5YS45MTMuOTEzIDAgMTExLjI5LTEuMjl6IiBpZD0iYSIvPjwvZGVmcz48dXNlIGZpbGw9IiNmZmYiIGZpbGwtcnVsZT0ibm9uemVybyIgeGxpbms6aHJlZj0iI2EiLz48L3N2Zz4=";
var Box = /*#__PURE__*/function (_PureComponent) {
  _inherits(Box, _PureComponent);
  var _super = _createSuper(Box);
  function Box() {
    var _this;
    _classCallCheck(this, Box);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "state", {
      hidden: _this.props.hidden || false,
      showMore: false
    });
    _defineProperty(_assertThisInitialized(_this), "getIsHidden", function () {
      if (_this.props.controlledHidden !== undefined) return _this.props.controlledHidden;
      return _this.state.hidden;
    });
    _defineProperty(_assertThisInitialized(_this), "onToggle", function () {
      var _this$props$onToggle, _this$props;
      _this.setState({
        hidden: !_this.state.hidden
      });
      (_this$props$onToggle = (_this$props = _this.props).onToggle) === null || _this$props$onToggle === void 0 ? void 0 : _this$props$onToggle.call(_this$props, !_this.getIsHidden());
    });
    _defineProperty(_assertThisInitialized(_this), "renderChildren", function () {
      if (_this.state.hidden && _this.props.lazy) return null;
      return _this.props.children;
    });
    return _this;
  }
  _createClass(Box, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.hidden !== this.props.hidden) {
        this.setState({
          hidden: this.props.hidden
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props2 = this.props,
        className = _this$props2.className,
        alt = _this$props2.alt,
        collapse = _this$props2.collapse,
        boxLabel = _this$props2.boxLabel,
        more = _this$props2.more,
        toggleOnHeaderClick = _this$props2.toggleOnHeaderClick;
      var showMore = this.state.showMore;
      var ariaAttributes = (0, _getObjectSubset.default)(this.props, 'aria');
      var headerAttributes = {};
      if (collapse && toggleOnHeaderClick) {
        headerAttributes['onClick'] = this.onToggle;
        headerAttributes['onKeyPress'] = this.onToggle;
        headerAttributes['role'] = "button";
        headerAttributes['tabIndex'] = 0;
      }
      var hidden = this.getIsHidden();
      return /*#__PURE__*/_react.default.createElement("section", _extends({}, ariaAttributes, {
        "aria-label": boxLabel,
        className: (0, _classnames.default)([className, 'box', 'sa-box', alt ? 'alt' : null, hidden ? 'box-collapse sa-box-collapse' : null])
      }), this.props.header ? /*#__PURE__*/_react.default.createElement("div", _extends({
        className: (0, _classnames.default)(['header', 'sa-box-header', toggleOnHeaderClick ? 'toggle-on-header-click' : null])
      }, headerAttributes), this.props.header, collapse && /*#__PURE__*/_react.default.createElement(_Button.default, {
        type: "button",
        onClick: function onClick() {
          return _this2.onToggle();
        },
        "aria-label": "Collapse ".concat(boxLabel || ''),
        className: (0, _classnames.default)({
          'box-header-button': true,
          'up': !hidden,
          'down': hidden,
          'hidden': hidden
        }),
        onKeyPress: function onKeyPress(e) {
          e.stopPropagation();
          _this2.onToggle();
        }
      }, /*#__PURE__*/_react.default.createElement("img", {
        className: "collapse-arrow ".concat(hidden ? 'down' : 'up'),
        src: alt ? downArrow : downArrowLight,
        alt: "Collapse ".concat(boxLabel || ''),
        title: "Collapse ".concat(boxLabel || '')
      }))) : null, /*#__PURE__*/_react.default.createElement("div", {
        "data-testid": "box-body",
        className: (0, _classnames.default)({
          'box-body': true,
          'sa-box-body': true,
          'hidden': hidden
        })
      }, this.renderChildren(), showMore && more, more && /*#__PURE__*/_react.default.createElement("div", {
        className: "sa-box-show-more"
      }, /*#__PURE__*/_react.default.createElement(_Button.default, {
        type: "button",
        onClick: function onClick() {
          return _this2.setState({
            showMore: !showMore
          });
        }
      }, /*#__PURE__*/_react.default.createElement("span", null, "Show ", showMore ? "Less" : "More", /*#__PURE__*/_react.default.createElement("img", {
        src: downArrow,
        className: (0, _classnames.default)({
          "rotate-180": showMore
        }),
        alt: ""
      }))))));
    }
  }]);
  return Box;
}(_react.PureComponent);
exports.default = Box;
_defineProperty(Box, "defaultProps", {
  header: undefined,
  className: undefined,
  alt: false,
  collapse: false,
  hidden: false,
  lazy: false,
  toggleOnHeaderClick: false
});